<template>
  <div>
    <el-container>
      <el-header height="78">
        <navbar />
      </el-header>
      <el-container>
        <div class="main-body">
          <div class="main-body-top">
            <div class="main-body-top-separator"></div>
            <div class="main-body-top-background"></div>
          </div>
          <div class="main-body-separator">
            <div class="main-body-content">
              <div class="main-body-left pull-left">
                <div class="nav-title"></div>
                <div class="nav-step read"></div>
                <div class="nav-arrow"></div>
                <div class="nav-step write"></div>
                <div class="nav-arrow"></div>
                <div class="nav-step submit"></div>
                <div class="nav-arrow"></div>
                <div class="nav-step confirm"></div>
                <div class="nav-arrow"></div>
                <div class="nav-step success"></div>
              </div>
              <div class="main-body-right pull-left">
                <el-container>
                  <el-main>
                    <app-main />
                  </el-main>
                </el-container>
              </div>
              <div class="Cle"></div>

              <div class="main-body-ad">
                <div class="main-body-ad-left">
                  <div class="main-body-ad-right"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-container>
      <el-footer height="130">
        <div class="footer">
          <div class="main">
            <table cellpadding="0" cellspacing="0" border="0" width="100%">
              <tbody>
                <tr>
                  <td>
                    温馨提示：请关注美的实验幼儿园微信公众号：mdsyyey，或扫一扫右边二维码，及时了解幼儿园最新信息，掌握幼儿学习，生活动态。
                  </td>
                  <td width="120">
                    <img :src="wechartImage" style="width: 100px" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { AppMain, Navbar } from "./components";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
  },
  data() {
    return {
      wechartImage: require("../assets/images/WeChat.jpg"),
    };
  },
};
</script>

<style lang="less">
body{
  background:url(../assets/images/Background.jpg) repeat-x top #9acfec;
}
.main-body {
  width: 1345px;
  background: url(../assets/images/MainBackground.jpg) repeat-x top #9acfec;
  margin: 0 auto;
}
.main-body-top {
  height: 28px;
  background: url(../assets/images/Corner.jpg) no-repeat right;
  position: relative;
}
.main-body-top-separator {
  background: url(../assets/images/Folio.jpg) no-repeat;
  height: 28px;
  width: 49px;
  margin-left: 216px;
}
.main-body-top-background {
  background: url(../assets/images/FolioRight.jpg) repeat-x;
  position: absolute;
  left: 265px;
  right: 21px;
  top: 0px;
  bottom: 0px;
}
.main-body-separator {
  background: url(../assets/images/MainSeparator.jpg) repeat-y left #fbfbf9;
}
.main-body-content {
  background: url(../assets/images/CornerCenter.jpg) repeat-y right;
  _height: 500px;
  min-height: 500px;
}
.main-body-left {
  padding-left: 10px;
}
.main-body-left .nav-title {
  padding-bottom: 10px;
  width: 198px;
  height: 50px;
  background: url(../assets/images/Title.jpg) no-repeat;
}
.main-body-left {
  & .nav-step{
    width: 199px;
    height: 61px;
    &.read{
      background: url(../assets/images/Read.jpg) no-repeat;
    }
    &.write{
      background: url(../assets/images/Write.jpg) no-repeat;
    }
    &.submit{
      background: url(../assets/images/Submit.jpg) no-repeat;
    }
    &.confirm{
      background: url(../assets/images/Confirm.jpg) no-repeat;
    }
    &.success{
      background: url(../assets/images/Success.jpg) no-repeat;
    }
  }
  
}
.main-body-left .nav-step {
  width: 199px;
  height: 61px;
}

.main-body-left .nav-arrow {
  height: 13px;
  background: url(../assets/images/Arrow.jpg) no-repeat center;
}
.main-body-right {
  margin-left: 60px;
  width: 1060px;
  line-height: 32px;
}
.main-body-ad {
  height: 242px;
  background: url(../assets/images/AdCenterNew.jpg) no-repeat left;
}
.main-body-ad-left {
  height: 378px;
}
.main-body-ad-right {
  height: 378px;
}

.main {
  width: 1345px;
  clear: both;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
.Cle {
  font-size: 0;
  line-height: 0;
  height: 0;
  display: block;
  clear: both;
}

.el-header {
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-footer {
  color: #333;
  text-align: center;
  border-top: 1px solid #c6c7c6;
  background: #eee;
}
.el-footer table {
  width: 100%;
  text-align: center;
  background: #eee;
}
.el-footer img {
  margin: 10px;
}

.el-aside {
  color: #333;
  text-align: center;
}

.el-main {
  color: #333;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>